import React from "react";
import { history } from "router";
// import { CASE_VIEW_ACTION } from "constants";

const BusinessProgramLink = (entity_name, record) => {
    return (
        <a
            href={`/entity/${encodeURI(entity_name)}?id=${record.key}&&type=${
                record.type
            }`}
            onClick={e => e.preventDefault()}
        >
            {entity_name}
        </a>
    );
};

export const createBusinessProgramLink = () =>
    function BusinessProgramLink(entity_name, record) {
        return (
            <a
                href={"javascript:void(0)"}
                onClick={() =>
                    history.push(
                        `/app/schemes/${
                            record.id
                        }`
                    )
                }
            >
                {entity_name}
            </a>
        );
    };

export default BusinessProgramLink;
